import { render, staticRenderFns } from "./not-arrival-to-cancel.vue?vue&type=template&id=0cb6e474&scoped=true"
import script from "./not-arrival-to-cancel.vue?vue&type=script&lang=js"
export * from "./not-arrival-to-cancel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb6e474",
  null
  
)

export default component.exports